import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { Loader2, GraduationCap, Lock, User } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useToast } from "../../hooks/use-toast";

export default function AdminLogin() {
  const { user, login, loading: authLoading } = useAuth();
  const [u, setU] = useState("admin");
  const [p, setP] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  if (authLoading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(u, p);
      toast({ title: "Welcome back!", description: "Logged in successfully." });
      navigate("/admin");
    } catch (err) {
      toast({ title: "Login failed", description: "Invalid username or password.", variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center gradient-hero relative overflow-hidden">
      <div className="absolute top-10 left-10 w-72 h-72 bg-yellow-400/20 animate-blob blur-3xl" />
      <div className="absolute bottom-10 right-10 w-80 h-80 bg-blue-400/20 animate-blob blur-3xl" style={{ animationDelay: "2s" }} />

      <div className="relative w-full max-w-md mx-4">
        <div className="bg-white rounded-3xl shadow-2xl p-8">
          <div className="flex items-center justify-center mb-6">
            <div className="h-16 w-16 rounded-2xl bg-[#0B2A6B] flex items-center justify-center">
              <GraduationCap className="h-8 w-8 text-yellow-400" strokeWidth={2.5} />
            </div>
          </div>
          <h1 className="text-2xl font-bold text-center text-[#0B2A6B]">Admin Login</h1>
          <p className="text-center text-sm text-slate-500 mt-1 mb-7">Kiki Centre Control Panel</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-sm font-semibold text-slate-700 mb-1.5 inline-block">Username</Label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                <Input className="pl-10" value={u} onChange={(e) => setU(e.target.value)} required />
              </div>
            </div>
            <div>
              <Label className="text-sm font-semibold text-slate-700 mb-1.5 inline-block">Password</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                <Input type="password" className="pl-10" value={p} onChange={(e) => setP(e.target.value)} required />
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-yellow-400 hover:bg-yellow-500 text-[#0B2A6B] font-bold h-11">
              {loading ? <><Loader2 className="h-4 w-4 animate-spin mr-2" />Logging in...</> : "Login"}
            </Button>
          </form>

          <p className="text-center text-xs text-slate-400 mt-6">
            Default credentials: <code className="bg-slate-100 px-1.5 py-0.5 rounded">admin / admin123</code>
          </p>
        </div>
      </div>
    </div>
  );
}
